var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.7333 19.8H2.19995V2.2H11.7333M19.8 11L15.4 15.7667L19.8 11ZM19.8 11L15.4 6.6L19.8 11ZM19.8 11H5.86662H19.8Z","stroke":_vm.iconColor,"stroke-width":"1.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }